var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showIntro || _vm.canEdit)?_c('div',{attrs:{"id":_vm.key},domProps:{"innerHTML":_vm._s(_vm.text)},on:{"click":_vm.edit}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }